import {
    LIMPA_DEFINICOES_SEGURADO,
    SET_OPEN_BUSCA_AVANCADA,
    SET_PARAMS_FILTER_IMPORTACAO,
    SET_PARAMS_FILTER_RELACOES_PREVIDENCIARIAS,
    SET_PARAMS_FILTER_RESTITUICAO,
    SET_PARAMS_FILTER_RESULTADOS,
    SET_TAB_INDEX
} from "../actionTypes";

const INITIAL_STATE = {
    tabIndex: 0,
    paramsFiltroImportacao: {
        pagina: 0,
        itensPorPagina: 20
    },
    openBuscaAvancada: false,
    paramsFiltroRelacoesPrevidenciarias: {
        pagina: 0,
        itensPorPagina: 20
    },
    paramsFiltroResultados: {
        pagina: 0,
        itensPorPagina: 20
    },
    paramsFiltroRestituicao: {
        pagina: 0,
        itensPorPagina: 20
    }
};

// eslint-disable-next-line
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_TAB_INDEX:
            return {
                ...state,
                tabIndex: action.payload.index
            };
        case SET_PARAMS_FILTER_IMPORTACAO:
            return {
                ...state,
                paramsFiltroImportacao: action.payload.reset ?
                    { ...INITIAL_STATE.paramsFiltroImportacao }
                    :
                    {
                        ...state.paramsFiltroImportacao,
                        ...action.payload.params
                    }
            };
        case SET_OPEN_BUSCA_AVANCADA:
            return {
                ...state,
                openBuscaAvancada: action.payload.open
            };
        case SET_PARAMS_FILTER_RELACOES_PREVIDENCIARIAS:
            return {
                ...state,
                paramsFiltroRelacoesPrevidenciarias: action.payload.reset ?
                    { ...INITIAL_STATE.paramsFiltroRelacoesPrevidenciarias }
                    :
                    {
                        ...state.paramsFiltroRelacoesPrevidenciarias,
                        ...action.payload.params
                    }
            };
        case SET_PARAMS_FILTER_RESULTADOS:
            return {
                ...state,
                paramsFiltroResultados: action.payload.reset ?
                    { ...INITIAL_STATE.paramsFiltroResultados }
                    :
                    {
                        ...state.paramsFiltroResultados,
                        ...action.payload.params
                    }
            };
        case SET_PARAMS_FILTER_RESTITUICAO:
            return {
                ...state,
                paramsFiltroRestituicao: action.payload.reset ?
                    { ...INITIAL_STATE.paramsFiltroRestituicao }
                    :
                    {
                        ...state.paramsFiltroRestituicao,
                        ...action.payload.params
                    }
            };
        case LIMPA_DEFINICOES_SEGURADO:
            return {
                ...INITIAL_STATE
            };
        default:
            return state;
    }
};
